import { gql } from "@apollo/client";

// ─── BdayGuestForm queries ───────────────────────────────────────────────────

export const GET_BDAY_GUEST = gql`
    query BdayGuest($id: ID!) {
        bdayGuest(id: $id) {
            id
            firstName
            lastName
            phoneNumber
            email
            urlSlug
            notes
            dietaryRequirements
            isFamily
        }
    }
`;

export const CREATE_BDAY_GUEST = gql`
    mutation CreateBdayGuest($input: BdayGuestInput!) {
        createBdayGuest(input: $input) {
            id
            firstName
            urlSlug
        }
    }
`;

export const UPDATE_BDAY_GUEST = gql`
    mutation UpdateBdayGuest($id: ID!, $input: UpdateBdayGuestInput!) {
        updateBdayGuest(id: $id, input: $input) {
            id
            firstName
            urlSlug
        }
    }
`;

// ─── BdayGuestList queries ───────────────────────────────────────────────────

export const GET_BDAY_GUESTS = gql`
    query BdayGuests {
        bdayGuests {
            id
            firstName
            lastName
            phoneNumber
            email
            urlSlug
            rsvpStatus
            plusOnes
            plusOneNames
            inviteSentAt
            followUp1SentAt
            followUp2SentAt
            eveReminderSentAt
            rsvpRespondedAt
            isFamily
            notes
            dietaryRequirements
            createdAt
        }
        bdayStats {
            totalGuests
            invitesSent
            attending
            notAttending
            pending
            maybe
            totalPlusOnes
            totalHeadcount
        }
    }
`;

export const DELETE_BDAY_GUEST = gql`
    mutation DeleteBdayGuest($id: ID!) {
        deleteBdayGuest(id: $id)
    }
`;

export const MARK_INVITE_SENT = gql`
    mutation MarkBdayInviteSent($id: ID!) {
        markBdayInviteSent(id: $id) {
            id
            inviteSentAt
        }
    }
`;

export const RESET_BDAY_RSVP = gql`
    mutation ResetBdayRsvp($id: ID!) {
        resetBdayRsvp(id: $id) {
            id
            rsvpStatus
            plusOnes
            rsvpRespondedAt
        }
    }
`;

export const UNMARK_INVITE_SENT = gql`
    mutation UnmarkBdayInviteSent($id: ID!) {
        unmarkBdayInviteSent(id: $id) {
            id
            inviteSentAt
        }
    }
`;

export const SEND_INVITE_SMS = gql`
    mutation SendBdayInviteSms($input: SendBdayInviteSmsInput!) {
        sendBdayInviteSms(input: $input) {
            id
            inviteSentAt
        }
    }
`;

export const SEND_FOLLOW_UP_SMS = gql`
    mutation SendBdayFollowUpSms($input: SendBdayFollowUpSmsInput!) {
        sendBdayFollowUpSms(input: $input) {
            id
            followUp1SentAt
            followUp2SentAt
        }
    }
`;

export const SEND_EVE_REMINDER_SMS = gql`
    mutation SendBdayEveReminderSms($input: SendBdayEveReminderSmsInput!) {
        sendBdayEveReminderSms(input: $input) {
            id
            eveReminderSentAt
        }
    }
`;

export const UPDATE_BDAY_GUEST_PHONE = gql`
    mutation UpdateBdayGuest($id: ID!, $input: UpdateBdayGuestInput!) {
        updateBdayGuest(id: $id, input: $input) {
            id
            phoneNumber
        }
    }
`;

// ─── RSVP page queries ──────────────────────────────────────────────────────

export const GET_BDAY_GUEST_BY_SLUG = gql`
    query BdayGuestBySlug($slug: String!) {
        bdayGuestBySlug(slug: $slug) {
            id
            firstName
            lastName
            rsvpStatus
            plusOnes
            plusOneNames
            rsvpRespondedAt
        }
    }
`;

export const SUBMIT_BDAY_RSVP = gql`
    mutation SubmitBdayRsvp($slug: String!, $input: RsvpInput!) {
        submitBdayRsvp(slug: $slug, input: $input) {
            id
            firstName
            rsvpStatus
            plusOnes
            rsvpRespondedAt
        }
    }
`;
